import { useState } from 'react';
import { Search, X, Clock, Smile, Hand, Users, Leaf, UtensilsCrossed, Gamepad2, Lightbulb, Heart, Flag } from 'lucide-react';
import { cn } from '../../lib/cn';
import { searchEmojis } from './emojiSearch';

const EMOJI_CATEGORIES = {
  recent: { icon: Clock, label: 'Récents', emojis: [] as string[] },
  smileys: {
    icon: Smile, label: 'Smileys',
    emojis: [
      "😀","😃","😄","😁","😆","😅","🤣","😂","🙂","😊",
      "😇","🥰","😍","🤩","😘","😗","😚","😙","🥲","😋",
      "😛","😜","🤪","😝","🤑","🤗","🤭","🫢","🤫","🤔",
      "🫡","🤐","🤨","😐","😑","😶","🫥","😏","😒","🙄",
      "😬","🤥","😌","😔","😪","🤤","😴","😷","🤒","🤕",
      "🤢","🤮","🤧","🥵","🥶","🥴","😵","🤯","🤠","🥳",
      "🥸","😎","🤓","🧐","😕","🫤","😟","🙁","☹️","😮",
      "😯","😲","😳","🥺","🥹","😦","😧","😨","😰","😥",
      "😢","😭","😱","😖","😣","😞","😓","😩","😫","🥱",
    ],
  },
  gestures: {
    icon: Hand, label: 'Gestes',
    emojis: [
      "👋","🤚","🖐️","✋","🖖","🫱","🫲","🫳","🫴","👌",
      "🤌","🤏","✌️","🤞","🫰","🤟","🤘","🤙","👈","👉",
      "👆","🖕","👇","☝️","🫵","👍","👎","✊","👊","🤛",
      "🤜","👏","🙌","🫶","👐","🤲","🤝","🙏","✍️","💪",
    ],
  },
  people: {
    icon: Users, label: 'Personnes',
    emojis: [
      "👶","👧","🧒","👦","👩","🧑","👨","👩‍🦱","🧑‍🦱","👨‍🦱",
      "👩‍🦰","🧑‍🦰","👨‍🦰","👱‍♀️","👱","👱‍♂️","👩‍🦳","🧑‍🦳","👨‍🦳","👩‍🦲",
      "🧑‍🦲","👨‍🦲","🧔‍♀️","🧔","🧔‍♂️","👵","🧓","👴","👲","👳‍♀️",
      "🧕","👮‍♀️","👮","👷‍♀️","👷","💂‍♀️","💂","🕵️‍♀️","🕵️","👩‍⚕️",
    ],
  },
  nature: {
    icon: Leaf, label: 'Nature',
    emojis: [
      "🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐻‍❄️","🐨",
      "🐯","🦁","🐮","🐷","🐸","🐵","🙈","🙉","🙊","🐒",
      "🐔","🐧","🐦","🐤","🐣","🐥","🦆","🦅","🦉","🦇",
      "🐺","🐗","🐴","🦄","🐝","🪱","🐛","🦋","🐌","🐞",
      "🌸","💮","🏵️","🌹","🥀","🌺","🌻","🌼","🌷","🌱",
    ],
  },
  food: {
    icon: UtensilsCrossed, label: 'Nourriture',
    emojis: [
      "🍎","🍐","🍊","🍋","🍌","🍉","🍇","🍓","🫐","🍈",
      "🍒","🍑","🥭","🍍","🥥","🥝","🍅","🍆","🥑","🥦",
      "🍕","🍔","🍟","🌭","🍿","🧂","🥓","🥚","🍳","🧇",
      "🥞","🧈","🍞","🥐","🥖","🥨","🧀","🥗","🥙","🌮",
      "☕","🍵","🧃","🥤","🧋","🍶","🍺","🍻","🥂","🍷",
    ],
  },
  activities: {
    icon: Gamepad2, label: 'Activités',
    emojis: [
      "⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱",
      "🪀","🏓","🏸","🏒","🏑","🥍","🏏","🪃","🥅","⛳",
      "🎯","🏹","🎣","🤿","🥊","🥋","🎽","🛹","🛼","🛷",
      "⛸️","🥌","🎿","⛷️","🏂","🪂","🏋️","🤼","🤸","🤺",
      "🎮","🕹️","🎲","🧩","♟️","🎭","🎨","🎬","🎤","🎧",
    ],
  },
  objects: {
    icon: Lightbulb, label: 'Objets',
    emojis: [
      "⌚","📱","📲","💻","⌨️","🖥️","🖨️","🖱️","🖲️","💽",
      "💾","💿","📀","📼","📷","📸","📹","🎥","📽️","🎞️",
      "📞","☎️","📟","📠","📺","📻","🎙️","🎚️","🎛️","🧭",
      "⏱️","⏲️","⏰","🕰️","💡","🔦","🏮","🪔","📔","📕",
      "💰","💳","💎","⚖️","🪜","🧰","🪛","🔧","🔨","⚒️",
    ],
  },
  symbols: {
    icon: Heart, label: 'Symboles',
    emojis: [
      "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔",
      "❤️‍🔥","❤️‍🩹","💕","💞","💓","💗","💖","💘","💝","💟",
      "✅","❌","⭕","❗","❓","❕","❔","💯","🔥","✨",
      "⭐","🌟","💫","💥","💢","💦","💨","🕳️","💬","👁️‍🗨️",
      "🗨️","🗯️","💭","💤","🎵","🎶","🔔","🔕","📣","📢",
    ],
  },
  flags: {
    icon: Flag, label: 'Drapeaux',
    emojis: [
      "🏳️","🏴","🏁","🚩","🏳️‍🌈","🏳️‍⚧️","🇫🇷","🇺🇸","🇬🇧","🇩🇪",
      "🇪🇸","🇮🇹","🇵🇹","🇧🇪","🇨🇭","🇨🇦","🇯🇵","🇨🇳","🇰🇷","🇧🇷",
    ],
  },
};

type CategoryKey = keyof typeof EMOJI_CATEGORIES;

const RECENT_KEY = 'cime_recent_emojis';
const MAX_RECENT = 20;

function getRecentEmojis(): string[] {
  try {
    const stored = localStorage.getItem(RECENT_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch { return []; }
}

function addRecentEmoji(emoji: string) {
  try {
    const recent = getRecentEmojis().filter((e) => e !== emoji);
    recent.unshift(emoji);
    localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
  } catch { /* ignore */ }
}

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onSelect, onClose }: EmojiPickerProps) {
  const [activeCategory, setActiveCategory] = useState<CategoryKey>('smileys');
  const [search, setSearch] = useState('');
  const recentEmojis = getRecentEmojis();

  function handleSelect(emoji: string) {
    addRecentEmoji(emoji);
    onSelect(emoji);
  }

  function getDisplayEmojis(): string[] {
    if (search.trim()) {
      return searchEmojis(search, Object.values(EMOJI_CATEGORIES).flatMap((c) => c.emojis));
    }
    if (activeCategory === 'recent') return recentEmojis;
    return EMOJI_CATEGORIES[activeCategory].emojis;
  }

  const emojis = getDisplayEmojis();

  return (
    <div className="absolute bottom-full left-0 mb-2 z-50 w-80 rounded-xl border border-cime-border bg-cime-surface shadow-xl">
      {/* Search */}
      <div className="flex items-center gap-2 border-b border-cime-border p-3">
        <Search className="w-4 h-4 text-cime-text-muted flex-shrink-0" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Rechercher un emoji…"
          className="flex-1 bg-transparent text-sm text-cime-text-primary placeholder:text-cime-text-muted outline-none"
          autoFocus
        />
        <button type="button" onClick={onClose} className="text-cime-text-muted hover:text-cime-text-primary transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Category tabs */}
      <div className="flex gap-1 overflow-x-auto border-b border-cime-border p-2 scrollbar-none">
        {(Object.entries(EMOJI_CATEGORIES) as [CategoryKey, typeof EMOJI_CATEGORIES[CategoryKey]][]).map(([key, cat]) => {
          if (key === 'recent' && recentEmojis.length === 0) return null;
          const Icon = cat.icon;
          return (
            <button
              key={key}
              type="button"
              onClick={() => { setActiveCategory(key); setSearch(''); }}
              title={cat.label}
              className={cn(
                'rounded-lg p-2 transition-colors flex-shrink-0',
                activeCategory === key
                  ? 'bg-cime-primary/10 text-cime-primary'
                  : 'text-cime-text-muted hover:bg-cime-primary/5 hover:text-cime-text-primary',
              )}
            >
              <Icon className="w-4 h-4" />
            </button>
          );
        })}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-8 gap-1 h-48 overflow-y-auto p-2">
        {emojis.length > 0 ? emojis.map((emoji, i) => (
          <button
            key={`${emoji}-${i}`}
            type="button"
            onClick={() => handleSelect(emoji)}
            className="flex h-8 w-8 items-center justify-center rounded text-xl hover:bg-cime-primary/10 transition-colors"
          >
            {emoji}
          </button>
        )) : (
          <div className="col-span-8 flex h-full items-center justify-center text-sm text-cime-text-muted">
            {activeCategory === 'recent' && !search.trim() ? "Pas d'emojis récents" : 'Aucun emoji trouvé'}
          </div>
        )}
      </div>
    </div>
  );
}
